module.exports = __webpack_public_path__ + "static/bmw-logo-fae9b53bf07c90bb08d009b8bf8d4d83.png";